module.exports = __webpack_public_path__ + "img/question-background-blur.6ef8cfd8.svg";